export default __webpack_public_path__ + "static/media/Snd_TryV.d311df87.mp3";